const FormatNumber = (num: number, n: number) => {
    return num.toFixed(n);
}

export default FormatNumber;